import {Component, OnInit } from '@angular/core';
import {merge, Observable, Observer, Subscription} from 'rxjs';
import {RecordsService} from '../shared/services/records.service';
import {UtilService} from '../shared/services/util.service';
import {Record} from '../models/record.model';
import {filter, map, shareReplay} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../shared/services/auth.service';
import {tap} from 'rxjs/internal/operators/tap';
// import { InfiniteScroll } from 'ngx-infinite-scroll';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  userFilter = {title: ''};
  groupsFilter = {groupName: ''};
  items$: Observable<Record[]>;
  osw$: Observable<Record[]>;
  groups: any[] = [];
  rgroups$: Observable<any>;

  inactiveStatus = 0;
  isEdited = 0;
  userId;
  userRecordsCount;
  array = [];
  sum = 100;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  modalOpen = false;

  constructor(public recordsService: RecordsService,
              public authService: AuthService,
              private route: ActivatedRoute) {}

  ngOnInit() {
    // this.isLoading = true;
    this.userId = this.authService.getUserId();
    this.userId = 2;
    this.groups = this.route.snapshot.data.groups;
    this.rgroups$ =  this.recordsService.userRecordsGroups(this.userId)
      .pipe(
        map(elems => {
          return elems;
        })
      );
    // this.recordsService.userRecords(this.userId).subscribe(result => {
    //   console.log(result.rows)
    // })
    const http$ = this.recordsService.userRecords(this.userId)
      .pipe(
      map(elems => elems)
    );
    const records$ = http$.pipe(shareReplay());
    this.items$ = records$.pipe(
      map(items => items.filter(el => el.recordType === 'Item')),
        tap(d =>   console.log('items', d))
    );
    this.osw$ = records$.pipe(
      map(items => items.filter(el => el.recordType === 'OSW')),
        tap(d =>   console.log('osw', d))
    );
    this.appendItems(0, this.sum);
  }

  onDelete(id: string) {
    this.recordsService.deleteRecord(id);
  }
  onGroupStatus(a) {
    const groupId = a;
    this.inactiveStatus = 1;
    this.isEdited = 1;
    const group = {
      inactive: this.inactiveStatus,
      isEdited: this.isEdited
    }
    this.recordsService.updateGroupStatus(groupId, group);
  }
  // SCROLL
  addItems(startIndex, endIndex, _method) {
    for (let i = 0; i < this.sum; ++i) {
      this.array[_method]([i, ' ', this.generateWord()].join(''));
    }
  }

  appendItems(startIndex, endIndex) {
    this.addItems(startIndex, endIndex, 'push');
  }

  prependItems(startIndex, endIndex) {
    this.addItems(startIndex, endIndex, 'unshift');
  }

  onScrollDown(ev) {
    console.log('scrolled down!!', ev);

    // add another 20 items
    const start = this.sum;
    this.sum += 20;
    this.appendItems(start, this.sum);

    this.direction = 'down';
  }

  onUp(ev) {
    console.log('scrolled up!', ev);
    const start = this.sum;
    this.sum += 20;
    this.prependItems(start, this.sum);

    this.direction = 'up';
  }
  generateWord() {
    console.log('word');
    // return chance.word();
  }

  toggleModal() {
    this.modalOpen = !this.modalOpen;
  }
}
